var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vista,attrs:{"id":"app"}},[_c('top-bar'),_c('div',{staticClass:"router-container"},[_c('router-view'),(_vm.footerText && !_vm.loading)?_c('app-footer',{attrs:{"text":_vm.footerText}}):_vm._e()],1),(_vm.loading)?_c('lottie-loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }